import React from 'react';
import { useTranslation } from 'react-i18next';
import './Certification.css';

const Certification: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="certification">
      <div className="certification-card">
        <div className="certification-logo">
          <img 
            src="/images/ministere.png" 
            alt={t('certification_text')} // For accessibility: use translated text as alt text
            className="ministry-logo"
          />
        </div>
        <div className="certification-text gr-title">
          {t('certification_text')}
        </div>
      </div>
    </section>
  );
};

export default Certification;
